import debug from 'debug';

debug.enable ('dataseal:*');

const base = debug ('dataseal');

export {
  base
};
